// import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';

import './FacebookIcon.style';

export class FacebookIcon extends PureComponent {
    static propTypes = {
        // TODO: implement prop-types
    };

    render() {
        return (
            <svg width="29" height="30" viewBox="0 0 29 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M14.5011 3.23633C7.82865 3.23633 2.41895 8.64604 2.41895 15.3185C2.41895 21.348 6.83661 26.3457 12.6137 27.2556V18.8117H9.54449V15.3185H12.6137V12.6565C12.6137 9.626 14.4177 7.95487 17.1763 7.95487C18.4982 7.95487 19.883 8.1905 19.883 8.1905V11.1618H18.3557C16.8573 11.1618 16.3885 12.0946 16.3885 13.0504V15.316H19.7368L19.2015 18.8093H16.3885V27.2532C22.1655 26.3481 26.5832 21.3492 26.5832 15.3185C26.5832 8.64604 21.1735 3.23633 14.5011 3.23633Z" fill="#FDF8F4" />
            </svg>
        );
    }
}

export default FacebookIcon;
